import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Privilege} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  uid: string
}

interface SearchResponse {
  privileges: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class PrivilegeConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/access/users/';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): Privilege {
    return {
      id: response.uid
    };
  }

  getAll(email: string): Observable<Privilege[]> {
    return this.http.get<SearchResponse>(this.getManyUrl(email)).pipe(
      map((response: SearchResponse) => response.privileges.map(
          (item: IResponseItem) => PrivilegeConnectors.transformFromApi(item)
        ),
        catchError(error => {
          console.error('Load Privilege error', error);
          return throwError(error);
        })
      ));
  }

  protected getManyUrl(email: string) {
    return this._rootUrl + this._baseSite + this.route + email + '/delegatorprivileges';
  }
}
